import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRightSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronRightSmall"><Path d="M10 16L14 12L10 8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronRightSmall;
